// extracted by mini-css-extract-plugin
export var background = "bB_x";
export var backgroundContainer = "bB_fj";
export var bottomImage = "bB_t";
export var bottomImageContainer = "bB_gq";
export var buttons = "bB_ct";
export var container = "bB_k";
export var imagesContainer = "bB_gp";
export var middleWave = "bB_ch";
export var section = "bB_b";
export var text = "bB_cq";
export var textContainer = "bB_bM";
export var title = "bB_f";
export var topImage = "bB_m";
export var waveOverlay = "bB_gn";